import { Router } from '@angular/router';
var ConsultasComponent = /** @class */ (function () {
    function ConsultasComponent(router) {
        this.router = router;
        this.consultas = [];
        this.loading = false;
        this.skeletonSlots = [0, 1, 2];
        this.detailOpen = false;
        this.selectedConsulta = null;
    }
    Object.defineProperty(ConsultasComponent.prototype, "items", {
        get: function () {
            return (this.consultas || []).slice(0, 3);
        },
        enumerable: true,
        configurable: true
    });
    ConsultasComponent.prototype.irA = function (link) {
        this.router.navigate([link]);
    };
    /** Abre el modal con el detalle de la consulta seleccionada. */
    ConsultasComponent.prototype.irDetalle = function (consulta) {
        this.selectedConsulta = consulta;
        this.detailOpen = true;
    };
    ConsultasComponent.prototype.closeDetail = function () {
        this.detailOpen = false;
        this.selectedConsulta = null;
    };
    return ConsultasComponent;
}());
export { ConsultasComponent };
